<template>
  <div>
    <ShopProductFullPrice :product="product" :quantity="quantity" />
    <template v-if="buyButtonEnabled">
      <div class="mt-6">
        <div class="flex flex-row items-center gap-4">
          <ShopProductQuantitySwitch
            v-model="quantity"
            :min-purchase="product?.minPurchase"
            :max-purchase="product?.maxPurchase"
            :purchase-steps="product?.purchaseSteps"
            size="lg"
          />
          <AppButton
            icon="shopping-bag"
            variant="primary"
            @click="addToCartProxy"
          >
            {{ $t('product.addToCart') }}
          </AppButton>
        </div>
      </div>
      <div v-if="extraConditionsText" class="mt-8">
        <span class="text-xs font-semibold">{{ extraConditionsText }}</span>
      </div>
    </template>
    <ShopProductStock v-if="!priceHidden" :product="product" class="mt-4" />
  </div>
</template>

<script setup lang="ts">
import { getTranslatedProperty } from '@shopware/helpers'
import type { Schemas } from '#shopware'

const props = defineProps<{
  product: Schemas['Product']
}>()

const { pushSuccess } = useNotifications()
const { t } = useI18n()
const { product } = toRefs(props)
const { addToCart, quantity } = useAddToCart(product)

const addToCartProxy = async () => {
  await addToCart()
  pushSuccess(
    t('cart.productAdded', {
      product: getTranslatedProperty(product.value, 'name'),
    })
  )
}

const priceHidden = computed(
  () => product.value.extensions?.hiddenPrice?.isHiddenPrice === true
)

const buyButtonEnabled = computed(() => !priceHidden.value)

const extraConditionsText = computed(() => {
  if (product.value?.customFields?.novu_jp_custom_products_extra_conditions) {
    return product.value.customFields.novu_jp_custom_products_extra_conditions
  }
})
</script>
